import { useCallback } from "react";

import { useProductOptionFormModelContext } from "../../../../../context";

export const useOptionDateTabbedTimeSelectionEnabled = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { isDateTabbedTimeSelectionEnabled, useAsSubOption } = viewModel;

	const isEdited = isDateTabbedTimeSelectionEnabled.isEdited;
	const hasError = Boolean(isDateTabbedTimeSelectionEnabled.error);

	const isEnabled = useAsSubOption.value;

	const onSetIsDateTabbedTimeSelectionEnabled = useCallback(
		(input: boolean) => {
			if (!useAsSubOption.value) return;

			onSetViewModel([
				{
					key: "isDateTabbedTimeSelectionEnabled",
					value: {
						...isDateTabbedTimeSelectionEnabled,
						value: input,
					},
				},
			]);
		},
		[isDateTabbedTimeSelectionEnabled, onSetViewModel, useAsSubOption.value],
	);

	return {
		isEdited,
		hasError,
		isEnabled,

		isDateTabbedTimeSelectionEnabled,
		onSetIsDateTabbedTimeSelectionEnabled,
	};
};
